import * as yup from 'yup'

import type {
  ProviderInputType,
  ProviderScheduleInputType,
} from 'types/providers'

import { ProviderFields } from 'components/Providers/ProviderForm'
import { ShiftsFields } from 'components/Providers/utils'
import i18next from 'i18n'
import { Certification } from 'utils/enums'
import { timeRegex } from 'utils/time'

export const ProviderInputSchema: yup.Schema<ProviderInputType> = yup
  .object()
  .shape({
    [ProviderFields.FIRSTNAME]: yup
      .string()
      .required(i18next.t('First name is required')),
    [ProviderFields.LASTNAME]: yup
      .string()
      .required(i18next.t('Last name is required')),
    [ProviderFields.CERTIFICATION]: yup
      .mixed<Certification>()
      .oneOf(Object.values(Certification))
      .required(i18next.t('Certification is required')),
    [ProviderFields.PROVIDER_SPECIALTY_IDS]: yup
      .array()
      .of(yup.string().required()),
    [ProviderFields.ORGANIZATION_ID]: yup.string().required(),
  })

export const ProviderShiftInputSchema: yup.Schema<ProviderScheduleInputType> =
  yup.object().shape({
    [ShiftsFields.DATE]: yup.string().required(i18next.t('Date is required')),
    [ShiftsFields.PROVIDER_ID]: yup.string().required(),
    [ShiftsFields.START_TIME]: yup
      .string()
      .matches(timeRegex, i18next.t('Start time is required'))
      .required(i18next.t('Start time is required')),
    [ShiftsFields.END_TIME]: yup
      .string()
      .matches(timeRegex, i18next.t('Start time is required'))
      .required(i18next.t('End time is required'))
      .test(
        'is-after',
        i18next.t('End time must be greater than start time'),
        function(value) {
          const { [ShiftsFields.START_TIME]: startTime } = this.parent
          return value > startTime
        },
      ),
  })
